import React from 'react';
import { BrandMark } from './BrandMark';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
interface StateScreenProps {
  /** Overline tag, e.g. "Sem conexão". */
  tag?: string;
  title: string;
  body: string;
  /** Extra explanatory lines, e.g. what still works offline. */
  points?: string[];
  icon?: React.ReactNode;
  primary?: {
    label: string;
    onClick: () => void;
  };
  secondary?: {
    label: string;
    onClick: () => void;
  };
  /** Dark card for states that interrupt the session. */
  tone?: 'light' | 'dark';
}

/**
 * The single global-state surface. Loading, empty, offline, error, locked,
 * permission, session, maintenance and update states all render through this.
 */
export function StateScreen({
  tag,
  title,
  body,
  points,
  icon,
  primary,
  secondary,
  tone = 'light'
}: StateScreenProps) {
  const dark = tone === 'dark';
  return <div className="px-2 pb-2 pt-4" data-id="element-1441" data-mp="64hptpkp3axi">
      <Card tone={tone} className="rounded-panel p-3 text-center" data-id="element-1442" data-mp="65jeiwumvvxp">
        <span className={`mx-auto grid h-16 w-16 place-items-center rounded-pill ${dark ? 'border border-gold/45 bg-deeper text-gold' : 'bg-sand-deep text-soft'}`} data-id="element-1443" data-mp="17spyzxlxxgr">
          {icon ?? <BrandMark size={28} data-id="element-1444" data-mp="3obyspk185df4" />}
        </span>

        {tag && <p className={`bee-overline mt-2 text-[9px] font-bold ${dark ? 'text-gold' : 'text-gold-deep'}`} data-id="element-1445" data-mp="3jdniv9axj2ww">
            {tag}
          </p>}

        <h1 className={`mt-1 text-title ${dark ? 'text-sand' : 'text-deep'}`} data-id="element-1446" data-mp="fwylodx8l5jw">
          {title}
        </h1>
        <p className={`mx-auto mt-1 max-w-[32ch] text-[13px] leading-relaxed ${dark ? 'text-ondark' : 'text-muted'}`} data-id="element-1447" data-mp="b5ypxbzustiz">
          {body}
        </p>

        {points && points.length > 0 && <ul className={`mx-auto mt-2 max-w-[32ch] space-y-1 text-left ${dark ? 'text-ondark' : 'text-deep'}`} data-id="element-1448" data-mp="13nb3cgiaagno">
            {points.map(point => <li key={point} className="flex items-start gap-2 text-[12.5px] leading-snug" data-id="element-1449" data-mp="2t4y5girj4tmo">
                <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-1450" data-mp="2x3ympwuczo7k" />
                {point}
              </li>)}
          </ul>}
      </Card>

      {primary && <Button variant="gold" size="lg" fullWidth className="mt-3" onClick={primary.onClick} data-id="element-1451" data-mp="29f5yynnw4mo1">
          {primary.label}
        </Button>}
      {secondary && <Button variant="outline" size="lg" fullWidth className="mt-2" onClick={secondary.onClick} data-id="element-1452" data-mp="20gaqt61ad2i3">
          {secondary.label}
        </Button>}
    </div>;
}